import {Component, Input} from '@angular/core';
import {HeaderStep, NewChargeStepType} from '../../domain/headerStep';
import {NewChargeContext} from '../../services/business/newChargeContext.service';
import {finalize} from 'rxjs/operators';
import {from, noop, Observable, of} from 'rxjs';
import {NavController} from '@ionic/angular';

@Component({
    selector: 'header-steps',
    templateUrl: './headerSteps.component.html',
    styleUrls: ['./headerSteps.component.scss']
})
export class HeaderStepsComponent {

    @Input() disableNavigation: boolean;

    @Input() context: NewChargeContext;
    currentStep: HeaderStep;

    @Input() set steps(steps: HeaderStep[]) {
        if (steps && steps.length > 1) {
            this.currentStep = steps[0];
            steps[0].selected = true;
        }
        this._steps = steps;
        this.selectAndCompleteSteps();
    }
    get steps(): HeaderStep[] {
        return this._steps;
    }

    @Input() set currentChargeStepType(currentStep: NewChargeStepType) {
        this._currentChargeStepType = currentStep;
        this.selectAndCompleteSteps();
    }
    get currentChargeStepType(): NewChargeStepType {
        return this._currentChargeStepType;
    }
    private _currentChargeStepType: NewChargeStepType;
    private _steps: HeaderStep[];

    constructor(private navController: NavController) {
    }

    goToStep(step: HeaderStep): void {
        if (this.disableNavigation || !this.context || this.context.goingToStep) {
            return;
        }
        const currentStepIndex: number = this._steps.findIndex(headerStep => headerStep === this.currentStep);
        const stepIndex: number = this._steps.findIndex(headerStep => headerStep === step);
        if (currentStepIndex != null && stepIndex != null && currentStepIndex > stepIndex) {
            this.context.goingToStep = true;
            this.resetContextFields(step.contextFieldToResetIfGoingPreviousStep);
            let navigationEvent: Observable<boolean | void> = of(noop());
            if (!!step.urlView) {
                navigationEvent = from(this.navController.navigateBack([step.urlView], {
                    queryParams: this.context.toQueryParam(),
                    replaceUrl: true
                }));
            }
            navigationEvent
                .pipe(finalize(() => this.context.goingToStep = false))
                .subscribe();
        }
    }

    private resetContextFields(contextFieldToResetIfGoingPreviousStep: string[]) {
        if (contextFieldToResetIfGoingPreviousStep != null) {
            contextFieldToResetIfGoingPreviousStep.forEach(field => this.context[field] = undefined);
        }
    }

    private selectAndCompleteSteps() {
        let stepIsReach: boolean = false;
        if (!!this._steps && !!this._steps.length) {
            this._steps.forEach(step => {
                if (step.newChargeStepType === this._currentChargeStepType) {
                    this.currentStep = step;
                    stepIsReach = true;
                }
                step.selected = !stepIsReach && step.newChargeStepType !== this._currentChargeStepType
                    || stepIsReach && step.newChargeStepType === this._currentChargeStepType;
                step.complete = !stepIsReach && step.newChargeStepType !== this._currentChargeStepType;
            });
        }
    }
}
